import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { AbstractHttpService } from './http-abstract.service';
import { ServiceProviderDto } from './dto';

@Injectable({
	providedIn: 'root'
})
export class HttpServiceProviderService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/service-provider', authService);
	}

	public search(search: string): Observable<ServiceProviderDto[]> {
		return super.doGet(true, `/search?search=${encodeURI(search)}`);
	}
}
